import { render, staticRenderFns } from "./LandingPagesBrandView.vue?vue&type=template&id=5474c152&scoped=true"
import script from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
export * from "./LandingPagesBrandView.vue?vue&type=script&lang=js"
import style0 from "./LandingPagesBrandView.vue?vue&type=style&index=0&id=5474c152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474c152",
  null
  
)

export default component.exports